<template>
  <div class="products-container m-auto pb-2">
    <div>
      <img
        :src="
          imgUrl(
            $template.products_shop_picture,
            'campaign_product_shop_personnalisation'
          )
        "
        alt=""
        class="w-full pb-0 lg:pb-4 p-4"
      />
      <div class="flex flex-wrap lg:mt-4 justify-center lg:justify-evenly mx-4 lg:mx-0">
        <div
          v-for="product in products"
          :key="product.id"
          class="bg-white my-2 lg:w-[48%] w-full"
        >
          <div class="flex flex-col md:flex-row p-4">
            <div
              class="relative md:w-1/3 w-2/3 mx-auto"
              :style="getBg(product)"
              style="
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                aspect-ratio: 1/1.4;
              "
            >
              <div class="hidden md:block" v-if="product.promotion_title || product.promotion_subtitle">
                <p
                  class="reduction-NS"
                  :style="setCartbridgePromotion($template)"
                >
                  {{ product.promotion_title }}<br />
                  <span class="text-sm">{{ product.promotion_subtitle }}</span>
                </p>
              </div>
            </div>
            <div class="md:w-2/3 flex flex-col justify-between">
              <div class="p-4">
                <p class="text-red font-bold text-xl">{{ product.name }}</p>
                <div
                  class="text-sm"
                  v-html="tagText(product.description)"
                ></div>
              </div>
            </div>
            
            <div class="block md:hidden" v-if="product.promotion_title || product.promotion_subtitle">
              <div class="border-t border-black w-full mb-1"></div>
              <p
                class="text-red font-bold text-2xl text-right"
              >
                {{ product.promotion_title }}<br />
              </p>
            </div>

          </div>

          <div class="flex m-4 justify-between sm:justify-end">
            <p class="my-auto mr-2">Quantité</p>
            <div class="lg:w-1/6 lg:mr-4 lg:mt-0 my-auto">
              <Field
                :id="'quantity-' + product.id"
                class="selectForm !w-fit"
                :name="'quantity'"
                as="select"
                value="1"
              >
                <option
                  v-for="option in product.quantity_max"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </Field>
            </div>
            <button
              class="button-product flex uppercase"
              @click="addProduct(product)"
            >
              <img src="@/assets/img/play.png" alt="" class="w-4 m-auto" />
              <p class="ml-2 text-[11px] lg:text-sm my-auto">{{ $template.products_button }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field } from 'vee-validate'

export default {
  components: {
    Field
  },
  emits: ['addToCart'],
  computed: {
    products() {
      return this.$store.products
    },
    isWinner() {
      return this.$store.isWheelWinner && this.$template.campaign_template_mechanic_id === 5
    }
  },
  methods: {
    getBg(product) {
      return (
        "background-image: url('" +
        this.imgUrl(product.illustration, 'products_illustration') +
        "')"
      )
    },
    setCartbridgePromotion(template) {
      return (
        'background-color: ' +
        template.cartridge_promotion_background_color +
        '; color: ' +
        template.cartridge_promotion_text_color
      )
    },
    addProduct(product) {
      let quantity = document.getElementById('quantity-' + product.id)
      this.$emit('addToCart', { id: product.id, quantity: quantity.value })
    }
  },
}
</script>

<style scoped>
.button-product {
  background-color: v-bind(
    "$template ? $template.products_button_background_color : ' '"
  );
  color: v-bind("$template ? $template.products_button_text_color : ' '");
}

.products-container {
  background-color: v-bind(
    "$template ? $template.products_background_color : ' '"
  );
}

.div-form {
  @apply lg:flex  w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}
</style>
